const DEFAULT_LANGUAGE = 'uk'
export function prefixLanguage(url = '') {
  const path = new URL(window.location)
  const lang = path.pathname.split('/')[1]
  return 2 >= lang.length && DEFAULT_LANGUAGE !== lang && '' !== lang ? `/${lang}${url}` : url
}
